import axios from "axios";
// import Log from "@/services/log.js"

// state
const state = () => ({
  status: "",
  token: localStorage.getItem("token") || "",
  user: {},
  permissions: {},
  urlAPI: "",
  paramId: "",
  showToken: false,
  invalidToken: false,
  assinatura: {},
  exibeLp: true,
  primeiroLogin: true,
  origem: true,
  exibeModalAtualizacao: true,
  exibeBannerUpgrade: true
});

// getters
const getters = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  getUserToken: state => state.token,
  getUser: state => state.user,
  getParamId: state => state.paramId,
  getShowToken: state => state.showToken,
  getInvalidToken: state => state.invalidToken,
  getAssinatura: state => state.assinatura,
  getExibeLp: state => state.exibeLp,
  getExibeAviso: state => state.exibeAviso,
  getPrimeiroLogin: state => state.primeiroLogin,
  getOrigem: state => state.origem,
  getExibeBannerUpgrade: state => state.exibeBannerUpgrade
};

// mutations
const mutations = {
  auth_request(state) {
    state.status = "loading";
  },

  auth_success(state, token) {
    state.status = "success";
    state.token = token;
  },

  auth_error(state) {
    state.status = "error";
  },

  logout(state) {
    state.status = "";
    state.token = "";
  },

  auth_user(state, user) {
    state.user = user;
  },

  setParamId(state, paramId) {
    state.paramId = paramId;
  },

  setShowToken(state, showToken) {
    state.showToken = showToken;
  },

  setInvalidToken(state, invalidToken) {
    state.invalidToken = invalidToken;
  },

  setAssinatura(state, assinatura) {
    state.assinatura = assinatura;
  },

  setExibeLp(state, exibeLp) {
    state.exibeLp = exibeLp;
  },

  setExibeAviso(state, aviso) {
    state.exibeAviso = aviso;
  },

  setToggleBannerUpgrade(state) {
    state.exibeBannerUpgrade = !state.exibeBannerUpgrade;
  },

  setPrimeiroLogin(state, primeiroLogin) {
    state.primeiroLogin = primeiroLogin;
  },

  setOrigem(state, origem) {
    state.origem = origem;
  },

  getApi(state, url) {
    //		console.log(url)
    var urlApi;
    if (url.indexOf("http://localhost") > -1) {
      urlApi = process.env.VUE_APP_ROOT_API_LOCAL;
    } else if (url.indexOf("rte-dev.econeteditora.com.br") > -1) {
      urlApi = process.env.VUE_APP_ROOT_API_DEV;
    } else if (url.indexOf("rte-homol.econeteditora.com.br") > -1) {
      urlApi = process.env.VUE_APP_ROOT_API_HOMOL;
    } else if (url.indexOf("rte.econeteditora.com.br") > -1) {
      urlApi = process.env.VUE_APP_ROOT_API_PROD;
    } else {
      urlApi = process.env.VUE_APP_ROOT_API_DEV;
    }
    // console.log(urlApi)

    state.urlAPI = urlApi;
  }
};

// actions
const actions = {
  setExibeLp({ commit }, bool) {
    commit("setExibeLp", bool);
  },
  setPrimeiroLogin({ commit }, bool) {
    commit("setPrimeiroLogin", bool);
  },
  login({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      commit("getApi", window.location.href.toString());
      let urlApi = state.urlAPI;

      if (
        document.referrer.indexOf("econeteditora.com.br") === -1 &&
        document.referrer.indexOf("econetcomex.com.br") === -1 &&
        window.location.href.toString().indexOf("localhost") === -1
      ) {
        //
        reject({
          error: "Acesso não autorizado!"
        });

        commit("setOrigem", false);
        return;
      }

      axios({
        url: urlApi + "Login/ValidarLogin/" + data,
        method: "GET"
      })
        .then(resp => {
          let token = resp.data.dados.token;
          let nome_usuario = resp.data.dados.nome_usuario;
          let primeiro_login = resp.data.dados.primeiro_login;
          let tutorial_cenario = resp.data.dados.tutorial_cenario;
          let usuario_pro = resp.data.dados.usuario_pro;
          let blExibeLp = resp.data.dados.exibe_lp;
          let ip = resp.data.dados.ip;
          let id_usuario = resp.data.dados.id_usuario;
          let email_usuario = resp.data.dados.email_usuario;
          let exibeAviso = resp.data.dados.exibe_aviso;

          let user = {
            id_usuario: id_usuario,
            nome_usuario: nome_usuario,
            email_usuario: email_usuario,
            usuario_pro: usuario_pro,
            primeiro_login: primeiro_login,
            tutorial_cenario: tutorial_cenario,
            blExibeLp: blExibeLp,
            exibeAviso: exibeAviso,
            ip: ip
          };

          if (usuario_pro) {
            localStorage.removeItem("token");
            localStorage.removeItem("nome_usuario");
            this.usuario_pro = true;
          } else {
            this.usuario_pro = false;
            let obj = {
              strIP: ip,
              strAgente: navigator.userAgent,
              strMetodoHttp: "GET",
              intIdUsuario: id_usuario,
              strNomeUsuario: nome_usuario,
              strLogin: email_usuario,
              strSenha: "-",
              blAcessoSistema: true
            };

            // new Log().reportLogin(obj);
          }

          this.idOriginal = id_usuario;
          localStorage.clear();
          localStorage.setItem("token", token);
          localStorage.setItem("nome_usuario", nome_usuario);
          localStorage.setItem("primeiro_login", primeiro_login);
          localStorage.setItem("tutorial_cenario", tutorial_cenario);
          localStorage.setItem("usuario_pro", usuario_pro);
          localStorage.setItem("verificarLP", true);
          localStorage.setItem("id_original", id_usuario);
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          commit("auth_success", token);
          commit("auth_user", user);
          commit("setOrigem", true);

          resolve(resp);
        })
        .catch(err => {
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        })
        .finally(() => {});
    });
  },

  preLogin({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      commit("getApi", window.location.href.toString());
      let urlApi = state.urlAPI;

      if (
        document.referrer.indexOf("econeteditora.com.br") === -1 &&
        document.referrer.indexOf("econetcomex.com.br") === -1 &&
        window.location.href.toString().indexOf("localhost") === -1
      ) {
        //
        reject({
          error: "Acesso não autorizado!"
        });

        commit("setOrigem", false);
        return;
      }

      axios({
        url: urlApi + "Login/ValidarPreLogin/" + data,
        method: "GET"
      })
        .then(resp => {
          let token = resp.data.dados.token;
          let nome_usuario = resp.data.dados.nome_usuario;
          let primeiro_login = resp.data.dados.primeiro_login;
          let tutorial_cenario = resp.data.dados.tutorial_cenario;
          let usuario_pro = resp.data.dados.usuario_pro;
          let blExibeLp = resp.data.dados.exibe_lp;
          let ip = resp.data.dados.ip;
          let id_usuario = resp.data.dados.id_usuario;
          let email_usuario = resp.data.dados.email_usuario;
          const alerts = localStorage.getItem("alerts");

          let user = {
            id_usuario: id_usuario,
            nome_usuario: nome_usuario,
            email_usuario: email_usuario,
            usuario_pro: usuario_pro,
            primeiro_login: primeiro_login,
            tutorial_cenario: tutorial_cenario,
            blExibeLp: blExibeLp,
            ip: ip
          };

          this.usuario_pro = false;
          let obj = {
            strIP: ip,
            strAgente: navigator.userAgent,
            strMetodoHttp: "GET",
            intIdUsuario: id_usuario,
            strNomeUsuario: nome_usuario,
            strLogin: email_usuario,
            strSenha: "-",
            blAcessoSistema: true
          };

          // new Log().reportLogin(obj);

          this.idOriginal = id_usuario;
          localStorage.clear();
          localStorage.setItem("token", token);
          localStorage.setItem("alerts", alerts);
          localStorage.setItem("nome_usuario", nome_usuario);
          localStorage.setItem("primeiro_login", primeiro_login);
          localStorage.setItem("tutorial_cenario", tutorial_cenario);
          localStorage.setItem("usuario_pro", usuario_pro);
          localStorage.setItem("verificarLP", true);
          localStorage.setItem("id_original", id_usuario);
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          commit("auth_success", token);
          commit("auth_user", user);
          commit("setOrigem", true);
          commit("setParamId", btoa(id_usuario));

          resolve(resp);
        })
        .catch(err => {
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        })
        .finally(() => {});
    });
  },

  obterAssinatura({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("getApi", window.location.href.toString());
      let urlApi = state.urlAPI;
      axios({
        url: urlApi + "Usuarios/obterAssinatura/" + state.paramId,
        method: "GET"
      })
        .then(resp => {
          if (resp.data.dados) {
            let assinatura = resp.data.dados;
            localStorage.setItem("assinatura", JSON.stringify(assinatura));
            commit("setAssinatura", assinatura);
          }

          resolve(resp);
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => {});
    });
  },

  verificarAlertas({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("getApi", window.location.href.toString());
      let urlApi = state.urlAPI;
      axios({
        url: urlApi + "Login/VerificaAlertas/" + state.user.id_usuario,
        method: "GET"
      })
        .then(resp => {
          let primeiroLogin = resp.data.dados.primeiro_login;
          let exibeLp = resp.data.dados.exibe_lp;
          // let exibeAviso = resp.data.dados.exibe_aviso;
          let exibeAviso =
            Date.now() < Date.parse("05/22/2023") ? resp.data.dados.exibe_aviso : false;
          // let exibeAviso = false

          if (state.user.id_usuario == 108727 || state.user.id_usuario == 101660) {
            primeiroLogin = true;
            exibeLp = true;
          }

          localStorage.setItem("primeiro_login", primeiroLogin);
          localStorage.setItem("exibeLp", exibeLp);
          localStorage.setItem("exibeAviso", exibeAviso);

          commit("setPrimeiroLogin", primeiroLogin);
          commit("setExibeLp", exibeLp);
          commit("setExibeAviso", exibeAviso);

          resolve(resp);
        })
        .catch(err => {
          localStorage.setItem("primeiro_login", true);
          localStorage.setItem("exibeLp", true);
          localStorage.setItem("exibeAviso", exibeAviso);
          reject(err);
        })
        .finally(() => {});
    });
  },

  setParamId({ commit }, paramId) {
    commit("setParamId", paramId);
  },

  setShowToken({ commit }, showToken) {
    commit("setShowToken", showToken);
  },

  setInvalidToken({ commit }, invalidToken) {
    commit("setInvalidToken", invalidToken);
  },

  setToggleBannerUpgrade({ commit }) {
    commit("setToggleBannerUpgrade");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
